import React from 'react';
import PropTypes from 'prop-types';
import { compose } from "recompose";
import { withStyles, TableHead, TableRow, TableCell, TableSortLabel } from "@material-ui/core";
import t from "../../languages/pl";
import withSubordinateUser from './../HOC/withSubordinateUser';
import { themeTypeToBool } from './../../utils/helpers';

const useStyles = theme => ({
    cell: {
        textAlign: "center",
        padding: theme.spacing(1)
    },
    iconCell:{
        justifyContent: "left",
        padding: theme.spacing(1)
    },
    sortIcon: {
        color: (themeTypeToBool(theme.palette.type) ? "#000" : "#0C0C0") + "!important"
    },
    disabledSortIcon: {
        color: (themeTypeToBool(theme.palette.type) ? "#D3D3D3" : "#808080") + "!important"
    }
});

const DriversTableHeader = ({ classes, order, onSortOrderChange, isEcoOrderActive, trophyOrder, onSortTrophyOrderChange, isTrophyOrderActive, nonAdminUser }) => {

    return (
        <TableHead>
            <TableRow>
                <TableCell className={classes.driverNameCell}>
                    {t.firstAndLastName}
                </TableCell>
                <TableCell className={classes.iconCell} sortDirection={trophyOrder}>
                    <TableSortLabel
                        active
                        direction={trophyOrder}
                        onClick={onSortTrophyOrderChange}
                        classes={{ icon: (isTrophyOrderActive ? classes.sortIcon : classes.disabledSortIcon) }}
                    >
                        {t.trophies}
                    </TableSortLabel>
                </TableCell>
                <TableCell className={classes.cell}>
                    RFID
                </TableCell>
                <TableCell className={classes.cell}>
                    {t.phone}
                </TableCell>
                <TableCell className={classes.cell}>
                    {t.emailAddressLabel}
                </TableCell>
                <TableCell className={classes.cell}>
                    {t.driveType}
                </TableCell>
                <TableCell className={classes.cell}>
                    {t.driveTypeOutsideZone}
                </TableCell>
                <TableCell className={classes.cell}>
                    {t.group}
                </TableCell>
                <TableCell className={classes.cell} sortDirection={order}>
                    <TableSortLabel
                        active
                        direction={order}
                        onClick={onSortOrderChange}
                        classes={{ icon: (isEcoOrderActive ? classes.sortIcon : classes.disabledSortIcon) }}
                    >
                        ECO
                    </TableSortLabel>
                </TableCell>
                {
                    !nonAdminUser
                    &&
                    <TableCell className={classes.cell}>
                        {t.manage}
                    </TableCell>
                }
            </TableRow>
        </TableHead>
    );
};

DriversTableHeader.propTypes = {
    classes: PropTypes.object,
    order: PropTypes.string,
    onSortOrderChange: PropTypes.func,
    isEcoOrderActive: PropTypes.bool,
    trophyOrder: PropTypes.string,
    onSortTrophyOrderChange: PropTypes.func,
    isTrophyOrderActive: PropTypes.bool,
    //withSubordinateUser
    nonAdminUser: PropTypes.bool
};

export default compose(
    withStyles(useStyles),
    withSubordinateUser
)(DriversTableHeader);
